import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

/** Formas disponibles del bloque de carga. */
export type SkeletonShape = 'line' | 'block' | 'circle';

/**
 * Bloque de carga con brillo (shimmer).
 *
 * Reserva el espacio del contenido futuro para evitar el salto de layout
 * cuando llega la respuesta del API.
 */
@Component({
  selector: 'app-skeleton',
  imports: [],
  templateUrl: './skeleton.component.html',
  styleUrl: './skeleton.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkeletonComponent {
  /** Forma del bloque. */
  readonly shape = input<SkeletonShape>('line');

  /** Ancho CSS (p. ej. `100%`, `120px`, `40ch`). */
  readonly width = input<string>('100%');

  /** Alto CSS. Si se omite, lo decide la forma. */
  readonly height = input<string>('');

  /** Numero de bloques a repetir. Util para simular filas de tabla. */
  readonly count = input<number>(1);

  /** Texto que anuncian los lectores de pantalla mientras se carga. */
  readonly label = input<string>('Cargando contenido');

  protected readonly items = computed(() =>
    Array.from({ length: Math.max(1, this.count()) }, (_, index) => index),
  );

  protected readonly resolvedHeight = computed(() => {
    const explicit = this.height();
    if (explicit) {
      return explicit;
    }

    switch (this.shape()) {
      case 'circle':
        return this.width();
      case 'block':
        return '96px';
      default:
        return '14px';
    }
  });
}
